import { Component } from '@angular/core';

@Component({
  selector: 'pm-sucursales-list',
  templateUrl: './sucursales-list.component.html',
  styleUrls: ['./sucursales-list.component.sass']
})
export class SucursalesListComponent {
  public pageTitle = 'SUCURSALES';

  public showSucursales = true;
  public showAddSucursal = false;
  public showEditSucursal = false;
  public editnumber = 0;
}
